import { PageHero, Container, Overline } from "../components/Section";
import { Calendar, Bell, ExternalLink } from "lucide-react";
import { Link } from "react-router-dom";

const LIVE_URL = "https://www.youtube.com/@sixthmountzionbaptisttemple/live";

export default function LiveStream() {
  return (
    <div data-testid="live-stream-page">
      <PageHero
        overline="Live Stream"
        title={<>Worship with us, <span className="brand-gradient-text">anywhere</span>.</>}
        kicker="Join Sixth Mount Zion's live broadcasts every Sunday at 10:00 AM and Wednesday Bible Study at 7:00 PM."
        image="/images/branding/pastor-worship.jpg"
      />

      <Container className="pb-32">
        {/* Live embed */}
        <div className="relative aspect-video bg-royal/40 mb-12 overflow-hidden group" data-testid="live-stream-embed">
          <iframe
            src="https://www.youtube.com/embed/live_stream?channel=UC_SMZBT_CHANNEL_ID&autoplay=0"
            title="Sixth Mount Zion Live Stream"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className="absolute inset-0 w-full h-full"
          />
        </div>

        <div className="grid md:grid-cols-3 gap-px bg-white/5 mb-16">
          <div className="bg-royal/40 p-8 flex gap-4 items-start">
            <Calendar className="h-6 w-6 text-gold shrink-0 mt-1" />
            <div>
              <div className="text-xs uppercase tracking-widest text-ember font-bold mb-1">Sunday</div>
              <div className="font-sans text-xl font-extrabold">Worship Service</div>
              <div className="text-white/70 mt-1">10:00 AM ET</div>
            </div>
          </div>
          <div className="bg-royal/40 p-8 flex gap-4 items-start">
            <Calendar className="h-6 w-6 text-gold shrink-0 mt-1" />
            <div>
              <div className="text-xs uppercase tracking-widest text-ember font-bold mb-1">Wednesday</div>
              <div className="font-sans text-xl font-extrabold">Bible Study</div>
              <div className="text-white/70 mt-1">7:00 PM ET</div>
            </div>
          </div>
          <div className="bg-royal/40 p-8 flex gap-4 items-start">
            <Bell className="h-6 w-6 text-gold shrink-0 mt-1" />
            <div>
              <div className="text-xs uppercase tracking-widest text-ember font-bold mb-1">Subscribe</div>
              <div className="font-sans text-xl font-extrabold">Never miss a service</div>
              <div className="text-white/70 mt-1 text-sm">Get notified when we go live.</div>
            </div>
          </div>
        </div>

        <div className="flex flex-wrap gap-4">
          <a
            href={LIVE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-wine px-8 py-3.5 rounded-full text-sm uppercase tracking-widest font-bold inline-flex items-center gap-2"
            data-testid="watch-on-youtube-btn"
          >
            Watch on YouTube <ExternalLink className="h-4 w-4" />
          </a>
          <Link to="/media-library" className="btn-ghost px-8 py-3.5 rounded-full text-sm uppercase tracking-widest font-bold">
            Past Sermons
          </Link>
        </div>
      </Container>
    </div>
  );
}
